import React, { useEffect, useState } from 'react';
import Script from 'next/script';
import styled from 'styled-components';
import BlockWrapper from './BlockWrapper';
import Container from '../interface/Container';

export const Title = styled.h2`
  color: var(--color-text-light);
  font-family: var(--font-tertiary);
  font-weight: var(--font-weight-regular);
  font-size: 3.8rem;
  margin-bottom: 4rem;
`;

export const FormWrapper = styled.div``;

const CalendlyWidgetBlock = ({ block }) => {
  const [calendlyCode, setCalendlyCode] = useState(false);

  let { calendlyId } = block;
  if (calendlyId === '' || calendlyId === undefined || calendlyId === null) {
    calendlyId = 'doubleshift/introduction-tour';
  }

  useEffect(() => {
    setCalendlyCode(
      '<div class="calendly-inline-widget" data-url="' +
        `https://calendly.com/${calendlyId}?` +
        'hide_event_type_details=1&' +
        'hide_gdpr_banner=1&' +
        'background_color=00656b&' +
        'text_color=ffffff&' +
        'primary_color=fbed01" style="min-width:320px;height:650px;"></div>'
    );

    return () => {
      setCalendlyCode('');
    };
  });

  return (
    <BlockWrapper>
      <Container>
        {block.mainTitle && <Title>{block.mainTitle}</Title>}
        <Script
          src="https://assets.calendly.com/assets/external/widget.js"
          type="text/javascript"
          strategy="afterInteractive"
        />
        <FormWrapper>
          <div dangerouslySetInnerHTML={{ __html: calendlyCode }} />
        </FormWrapper>
      </Container>
    </BlockWrapper>
  );
};

export default CalendlyWidgetBlock;
